module.exports = __webpack_public_path__ + "img/csbank.cba10e1c.png";